module.exports = __webpack_public_path__ + "static/media/nina.ee48c0e3.jpg";